module.exports = __webpack_public_path__ + "img/denglogo.556e8e0e.png";